module.exports = __webpack_public_path__ + "static/media/account_black.af9d6e93.svg";